import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/axios";

export default function ForgotPassword() {
	const [email, setEmail] = useState("");
	const [submitted, setSubmitted] = useState(false);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	
	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		setLoading(true);
		try {
			await api.post("/auth/forgot-password", { email });
			setSubmitted(true);
		} catch (err) {
			setError(
				err.response?.data?.error ||
				"Something went wrong. Please try again."
			);
		} finally {
			setLoading(false);
		}
	};
	
	if (submitted) {
		return (
			<div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8
			text-center border border-farm-tan/30
			dark:border-gray-700 max-w-sm mx-auto">
			<div className="text-5xl mb-4">📬</div>
			<h2 className="text-2xl font-bold text-farm-green dark:text-green-400
			mb-3">
			Check Your Email
			</h2>
			<p className="text-gray-600 dark:text-gray-400 text-sm mb-6">
			If an account exists for{" "}
			<span className="font-semibold">{email}</span>, we sent a password
			reset link. Check your inbox and spam folder. The link expires
			in <strong>1 hour</strong>.
			</p>
			<Link
			to="/login"
			className="text-farm-green dark:text-green-400 font-semibold
			hover:underline text-sm"
			>
			← Back to sign in
			</Link>
			</div>
		);
	}
	
	return (
		<div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8
		border border-farm-tan/30 dark:border-gray-700
		max-w-sm mx-auto transition-colors duration-200">
		<div className="text-center mb-6">
		<div className="text-5xl mb-3">🔑</div>
		<h2 className="text-2xl font-bold text-farm-green dark:text-green-400">
		Reset Your Password
		</h2>
		<p className="text-gray-500 dark:text-gray-400 text-sm mt-2">
		Enter your email address and we'll send you a reset link.
		</p>
		</div>
		
		{error && (
			<div className="bg-red-50 dark:bg-red-900/30 border border-red-300
			dark:border-red-600 text-red-700 dark:text-red-300
			rounded-lg p-3 mb-4 text-sm">
			{error}
			</div>
		)}
		
		<form onSubmit={handleSubmit} className="space-y-4">
		<div>
		<label className="block text-sm font-medium text-gray-700
		dark:text-gray-300 mb-1">
		Email Address
		</label>
		<input
		type="email"
		required
		value={email}
		onChange={(e) => setEmail(e.target.value)}
		placeholder="you@example.com"
		className="w-full border border-gray-300 dark:border-gray-600
		rounded-lg px-3 py-2 bg-white dark:bg-gray-700
		text-gray-800 dark:text-gray-100
		placeholder-gray-400 dark:placeholder-gray-500
		focus:outline-none focus:ring-2 focus:ring-farm-green"
		/>
		</div>
		
		<button
		type="submit"
		disabled={loading}
		className="w-full bg-farm-green text-white py-3 rounded-xl
		font-semibold hover:bg-green-700 transition-colors
		disabled:opacity-60"
		>
		{loading ? "Sending…" : "Send Reset Link"}
		</button>
		</form>
		
		<p className="mt-4 text-center text-sm text-gray-500 dark:text-gray-400">
		Remembered it?{" "}
		<Link
		to="/login"
		className="text-farm-green dark:text-green-400 font-semibold
		hover:underline"
		>
		Back to sign in
		</Link>
		</p>
		</div>
	);
}
